import './_apis_';
import 'simplebar/src/simplebar.css';
import './utils/highlight';
import 'react-quill/dist/quill.snow.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';
import 'leaflet-geometryutil';
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { store, persistor } from './redux/store';
import { AuthProvider } from './contexts/FirebaseContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import './locales/i18n';
import App from './App';

const rootElement = document.getElementById("root")
const root = createRoot(rootElement);

root.render(
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AuthProvider>
        <HelmetProvider>
          <CollapseDrawerProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
          </CollapseDrawerProvider>
        </HelmetProvider>
      </AuthProvider>
    </PersistGate>
  </ReduxProvider>
);
